'use client'

import React, { forwardRef } from 'react'

import Icon from '../Icon'
import { KeyboardButton, KeyboardWrapper } from './Keyboard.styles'

interface KeyboardProps {
  value?: string | null
  onChange: (value: string) => void
  maxLength?: number
}

const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace']

const Keyboard = forwardRef<HTMLDivElement, KeyboardProps>(({ value, onChange, maxLength = 10 }, ref) => {
  const handleKeyPress = (key: string) => {
    if (key === 'backspace') {
      onChange((value ?? '').slice(0, -1))
    } else if (!value || value.length < maxLength) {
      onChange((value ?? '') + key)
    }
  }

  return (
    <KeyboardWrapper ref={ref}>
      {keys.map(key => (
        <KeyboardButton key={key} type="button" onClick={() => handleKeyPress(key)} wide={key === 'backspace'}>
          {key === 'backspace' ? <Icon name="backspace" /> : key}
        </KeyboardButton>
      ))}
    </KeyboardWrapper>
  )
})

Keyboard.displayName = 'Keyboard'

export default Keyboard
